module.exports = __webpack_public_path__ + "img/bg.336a4ee6.png";